import { useEffect, useState } from "react";
import apiGet from "../api/apiGet";
import ArrowUpRight from "../components/ui/ArrowUpRight";
import CustomButton from "../components/ui/CustomButton";
import PostFilters from "../components/ui/PostFilters";

const LatestPosts = (atts) => {
  let {
    exclude,
    hide_filters = false,
    layout = "grid",
    per_page = 9,
    load_more = true,
  } = atts;

  console.log(
    "%cTEST ->\n\tatts[%s]: %O",
    "font-size: 14px; color: #DC143C;",
    typeof atts,
    atts
  );

  if (typeof hide_filters === "string") hide_filters = JSON.parse(hide_filters);
  if (typeof load_more === "string") load_more = JSON.parse(load_more);

  console.log(
    "%cTEST ->\n\tload_more[%s]: %O",
    "font-size: 14px; color: #DC143C;",
    typeof load_more,
    load_more
  );

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [posts, setPosts] = useState([]);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalPosts, setTotalPosts] = useState(0);

  const [filters, setFilters] = useState({});

  const getPosts = async ({ clearPosts = false }) => {
    try {
      setError(null);
      setLoading(true);

      let query = {
        per_page,
        page,
      };

      if (exclude) query.exclude = exclude;
      if (filters) query = { ...query, ...filters };

      const response = await apiGet({
        url: `${rafa_react_components.home_url}/wp-json/wp/v2/posts`,
        debug: true,
        query,
      });

      if (clearPosts) setPosts(response.data);
      else setPosts([...posts, ...response.data]);

      setTotalPages(response.headers["x-wp-totalpages"]);
      setTotalPosts(response.headers["x-wp-total"]);
      setLoading(false);
    } catch (err) {
      if (err.code === "rest_post_invalid_page_number") {
        setLoading(false);
      } else {
        console.error(err);
        setError(err);
      }
    }
  };

  useEffect(() => {
    getPosts({});
  }, []);

  useEffect(() => {
    getPosts({ clearPosts: false });
  }, [page]);

  useEffect(() => {
    getPosts({ clearPosts: true });
  }, [filters]);

  return error ? (
    <>Error...</>
  ) : (
    <>
      <div className={`gallery-container gallery-${layout}`}>
        {!hide_filters && (
          <div className="filters w-full grow-0 shrink-0 !pb-3">
            <PostFilters {...{ filters, setFilters }} />
          </div>
        )}

        <div className={`gallery`}>
          <div className={`gallery-wrapper`}>
            {posts.length < 1 ? (
              <div className="!py-[200px] !px-10 text-center bg-gray-100 col-span-3 rounded-lg">
                No posts found.
              </div>
            ) : (
              <>
                {posts.map((post) => (
                  <a
                    class={`gallery-item mb-8 md:mb-0`}
                    href={post.link}
                    key={post.id}
                  >
                    <div className="aspect-square overflow-hidden mb-3">
                      <img
                        className="w-full h-full aspect-square object-cover hover:scale-105 transition duration-300 ease-in-out"
                        src={
                          post.featured_img_url || "https://placehold.co/600"
                        }
                      />
                    </div>
                    <h4 className="text-[12px] font-semibold text-rafa-red uppercase">
                      {post.time_ago} ago
                    </h4>
                    <div className="flex flex-row flex-no-wrap justify-between items-start">
                      <div
                        className="post-title text-[20px] uppercase font-semibold shrink"
                        dangerouslySetInnerHTML={{
                          __html: post.title.rendered,
                        }}
                      ></div>
                      <div className="shrink-0 text-rafa-red w-[48px] !pl-2">
                        <ArrowUpRight className="w-full h-full" />
                      </div>
                    </div>
                  </a>
                ))}
              </>
            )}

            {loading && (
              <div
                className={`loader animate-pulse text-2xl bg-gray-100 p-10 flex justify-center`}
              >
                Loading...
              </div>
            )}

            <div
              className={`bg-gray-100 flex justify-center items-center px-4 py-[20px] mt-3 min-w-[50px] col-span-3 ${page >= totalPages ? "!invisible" : ""}`}
            >
              {load_more && (
                <CustomButton
                  disabled={loading || page >= totalPages}
                  nodeType="button"
                  style="secondary"
                  label="Load more"
                  icon={false}
                  addon_class="w-fit px-[50px]"
                  onClick={() => {
                    setPage(page + 1);
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LatestPosts;
